export default () => !! (new Error()).stack
    .split('\n')
    .find((item) => item.startsWith('devtoolPlugin') ||
        item.startsWith('formatStoreForInspectorState'));
